<template>
	<div style="width:90%">
		<div class="container_body">
			<header class="header_nav">
				<el-form :inline="true" class="demo-form-inline" :model="searchInfo" style="margin: 20px 0px 0px 20px;">
					<el-form-item label="用户ID" class='tiny'>
						<el-input style="width: 200px;" v-model="searchInfo.id" placeholder="请输入用户ID"></el-input>
					</el-form-item>
					<el-form-item label="手机号" class='tiny'>
						<el-input style="width: 200px;" v-model="searchInfo.phone" placeholder="请输入用户手机号"></el-input>
					</el-form-item>
					<el-form-item label="账号" class='tiny'>
						<el-input style="width: 200px;" v-model="searchInfo.username" placeholder="请输入用户账号"></el-input>
					</el-form-item>
					<el-form-item label="会员级别" class='tiny'>
						<el-select v-model="searchInfo.userLevel" class="big" placeholder="请选择会员级别" clear>
							<el-option :key="0" label="会员" :value="0">会员</el-option>
							<el-option :key="1" label="经理v1" :value="1">经理v1</el-option>
							<el-option :key="2" label="县代v2" :value="2">县代v2</el-option>
							<el-option :key="3" label="区代v3" :value="3">区代v3</el-option>
							<el-option :key="4" label="市代v4" :value="4">市代v4</el-option>
							<el-option :key="5" label="省代v5" :value="5">省代v5</el-option>
							<el-option :key="6" label="分公司v6" :value="6">分公司v6</el-option>
							<el-option :key="7" label="合伙人v7" :value="7">合伙人v7</el-option>
						</el-select>
					</el-form-item>
					<!-- <el-form-item label="社区级别" class='tiny'>
						<el-select v-model="searchInfo.vipLevel" class="big" placeholder="请选择社区级别" clear>
							<el-option :key="1" label="部长" :value="1">部长</el-option>
							<el-option :key="2" label="经理" :value="2">经理</el-option>
							<el-option :key="3" label="总监" :value="3">总监</el-option>
						</el-select>
					</el-form-item> -->
					<!-- <el-form-item label="代理级别" class='tiny'>
						<el-select v-model="searchInfo.agentLevel" class="big" placeholder="请选择社区级别" clear>
							<el-option :key="1" label="省代" :value="1">省代</el-option>
							<el-option :key="2" label="市代" :value="2">市代</el-option>
							<el-option :key="3" label="区代" :value="3">区代</el-option>
						</el-select>
					</el-form-item> -->
					<el-form-item label="时间">
						<div class="block">
							<el-date-picker v-model="searchInfo.timer" value-format="yyyy-MM-dd HH:mm:ss"
								type="datetimerange" start-placeholder="开始日期" end-placeholder="结束日期"
								:default-time="['00:00:00', '23:59:59']">
							</el-date-picker>
						</div>
					</el-form-item>
					<el-form-item>
						<template>
							<el-button type="primary" @click="search">查询</el-button>
							<el-button @click="empty">清空</el-button>
							<!-- <el-button type="primary" @click="downloadFile"> 导出 </el-button> -->
						</template>
					</el-form-item>
				</el-form>
			</header>
		</div>
		<el-table :data="userList.list" stripe style="width: 100%;" :header-cell-style="headClass" v-loading="loading"
			element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">
			<el-table-column type="expand">
				<template slot-scope="props">
					<el-form label-position="left" inline class="demo-table-expand" label-width="300px">
						<el-form-item label="账号">
							<span>{{ props.row.username }}</span>
						</el-form-item>
						<!-- <el-form-item label="openid">
							<span>{{ props.row.openId?props.row.openId:'无' }}</span>
						</el-form-item> -->
						<el-form-item label="会员级别">
							<span v-if="props.row.userLevel==0">会员</span>
							<span v-if="props.row.userLevel==1">经理v1</span>
							<span v-if="props.row.userLevel==2">县代v2</span>
							<span v-if="props.row.userLevel==3">区代v3</span>
							<span v-if="props.row.userLevel==4">市代v4</span>
							<span v-if="props.row.userLevel==5">省代v5</span>
							<span v-if="props.row.userLevel==6">分公司v6</span>
							<span v-if="props.row.userLevel==7">合伙人v7</span>
						</el-form-item>
						<!-- <el-form-item label="社区级别">
							<span v-if="props.row.vipLevel==1">部长</span>
							<span v-if="props.row.vipLevel==2">经理</span>
							<span v-if="props.row.vipLevel==3">总监</span>
						</el-form-item> -->
						<!-- 		<el-form-item label="代理级别">
							<span v-if="props.row.agentLevel==1">省级运营中心</span>
							<span v-if="props.row.agentLevel==2">市级运营中心</span>
							<span v-if="props.row.agentLevel==3">区级运营中心</span>
							<span v-if="props.row.agentLevel==0">无</span>
						</el-form-item> -->
						<!-- 						<el-form-item label="是否爆品激活">
							<span v-if="props.row.userConsume==1">是</span>
							<span v-if="props.row.userConsume==0">否</span>
						</el-form-item> -->
						<el-form-item label="邀请码">
							<span>{{ props.row.invitationCode }}</span>
						</el-form-item>
						<el-form-item label="直推人数(有效)" width="180">
							<span>{{ props.row.inviterCount+"("+props.row.inviterCount+")" }}</span>
						</el-form-item>
						<el-form-item label="邀请人id">
							<span>{{ props.row.inviterUserId }}</span>
						</el-form-item>
						<el-form-item label="邀请人账号">
							<span>{{ props.row.invName }}</span>
						</el-form-item>
						<el-form-item label="邀请人昵称">
							<span>{{ props.row.invNickName }}</span>
						</el-form-item>
						<el-form-item label="邀请人手机号">
							<span>{{ props.row.invPhone }}</span>
						</el-form-item>
						<!-- 				<el-form-item label="福利池积分">
							<span>{{ props.row.flowTotal }}</span>
						</el-form-item> -->
						<el-form-item label="上次登录日期">
							<span>{{formartDate(props.row.updateDate)}}</span>
						</el-form-item>
					</el-form>
				</template>
			</el-table-column>
			<el-table-column prop="id" label="用户ID" sortable align="center" width="90">
			</el-table-column>
			<el-table-column prop="logo" label="头像" align="center" :formatter="changeNull">
				<template slot-scope="scope">
					<img :src="scope.row.logo" style="width: 50px;height: 50px;border-radius: 50%;" />
				</template>
			</el-table-column>
			<el-table-column prop="username" label="账号" align="center" :show-overflow-tooltip="true"
				:formatter="changeNull">
			</el-table-column>
			<el-table-column prop="nickname" label="昵称" align="center" :show-overflow-tooltip="true"
				:formatter="changeNull">
			</el-table-column>
			<el-table-column prop="phone" label="手机号" align="center" :show-overflow-tooltip="true"
				:formatter="changeNull">
			</el-table-column>
			<el-table-column prop="userLevel" label="会员等级" align="center" :show-overflow-tooltip="true">
				<template slot-scope="scope">
					<div v-if="scope.row.userLevel == 0">会员</div>
					<div v-if="scope.row.userLevel == 1">经理v1</div>
					<div v-if="scope.row.userLevel == 2">县代v2</div>
					<div v-if="scope.row.userLevel == 3">区代v3</div>
					<div v-if="scope.row.userLevel == 4">市代v4</div>
					<div v-if="scope.row.userLevel == 5">省代v5</div>
					<div v-if="scope.row.userLevel == 6">分公司v6</div>
					<div v-if="scope.row.userLevel == 7">合伙人v7</div>
				</template>
			</el-table-column>
			<el-table-column prop="invName" label="邀请人" align="center" :show-overflow-tooltip="true"
				:formatter="changeNull">
			</el-table-column>
			<el-table-column prop="inviterCount" label="邀请人数" align="center" :show-overflow-tooltip="true">
			</el-table-column>
			<el-table-column prop="shopStrength" label="消费总金额" align="center" :show-overflow-tooltip="true"
				:formatter="changeNull">
			</el-table-column>
			<el-table-column prop="createDate" label="注册时间" align="center" :show-overflow-tooltip="true">
			</el-table-column>

			<el-table-column prop="isEnable" label="状态" align="center" width="60">
				<template slot-scope="scope">
					<p v-if="!scope.row.isEnable">禁用</p>
					<p v-else>启用</p>
				</template>
			</el-table-column>
			<el-table-column label="操作" align="center">
				　<template slot-scope="scope">
					　
					<!-- <el-button size="small" type="text" @click="dialogVisibleFun(scope.row.id)">
						充值</el-button> -->
					<el-dropdown trigger="click" style="margin-left: 10px;">
						<el-button type="text" size="small">更多</el-button>
						<el-icon class="el-icon-caret-bottom"></el-icon>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item @click.native="toShowInvite(scope.row.id)">邀请关系
							</el-dropdown-item>
							<el-dropdown-item @click.native="toShowProperty(scope.row.id)">查看资产
							</el-dropdown-item>
							<!-- <el-dropdown-item @click.native="toShowPropertyFl(scope.row.id)">福利池变动记录
							</el-dropdown-item>
							<el-dropdown-item @click.native="showEditUserDialogVisible(scope.row.id)">编辑
							</el-dropdown-item>
								<el-dropdown-item @click.native="showEditAgentDialogVisible(scope.row.id)">设置代理
							</el-dropdown-item>
							<el-dropdown-item @click.native="toEditPassword(scope.row.id)">重置密码
							</el-dropdown-item>
							<el-dropdown-item v-if="scope.row.isEnable" @click.native="toDelete(scope.row)">禁用
							</el-dropdown-item>
							<el-dropdown-item v-else @click.native="toDelete(scope.row)">启用
							</el-dropdown-item> -->
						</el-dropdown-menu>
					</el-dropdown>
				</template>
				　　</el-table-column>
		</el-table>
		<el-pagination style="margin: 20px 0px 20px 0px ;" background :current-page="userList.pageNum"
			@current-change="pageChange" layout="total, sizes, prev, pager, next, jumper" :total="userList.total"
			@size-change="handleSizeChange">
		</el-pagination>
		<!-- 查看资产 -->
		<el-dialog style="float: rigin" title="用户资产" :visible.sync="propertyDialogVisible" width="60%">
			<el-table :data="userPropertyList" stripe style="width: 100%;" :header-cell-style="headClass"
				v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" row-key="id"
				:tree-props="{children: 'children', hasChildren: 'hasChildren'}">
				<el-table-column prop="username" label="账号" align="center" :show-overflow-tooltip="true">
				</el-table-column>
				<el-table-column prop="nickname" label="昵称" align="center" :show-overflow-tooltip="true">
				</el-table-column>
				<el-table-column prop="phone" label="手机号" align="center" :show-overflow-tooltip="true">
				</el-table-column>
				<el-table-column prop="introduce" label="资产名称" align="center" :show-overflow-tooltip="true">
				</el-table-column>
				<el-table-column prop="total" label="可用数量" align="center" :show-overflow-tooltip="true">
				</el-table-column>
				<el-table-column prop="lockCnt" label="冻结数量" align="center" :show-overflow-tooltip="true">
				</el-table-column>
			</el-table>
		</el-dialog>
		<!-- 编辑用户信息 -->
		<el-dialog style="float:rigin" title="编辑" :visible.sync="editUserDialogVisible" :close-on-click-modal="false"
			width="50%">
			<div class="app-container" style="text-align: center;">
				<el-form size="medium">
					<div style="display: flex;align-items: center;justify-content: space-between;">
						<el-form-item label="用户账号:" label-width="80px">
							<el-input v-model="userForm.nickname" :disabled="true" />
						</el-form-item>
						<el-form-item label="手机号:" label-width="80px">
							<el-input v-model="userForm.phone" :disabled="true" />
						</el-form-item>
					</div>
					<div style="display: flex;align-items: center;justify-content: space-between;">
						<el-form-item label="会员级别:" label-width="80px">
							<el-select v-model="userForm.userLevel" placeholder="请选择会员级别">
								<el-option :key="0" label="会员" :value="0">会员</el-option>
								<el-option :key="1" label="经理V1" :value="1">经理v1</el-option>
								<el-option :key="2" label="县代v2" :value="2">县代v2</el-option>
								<el-option :key="3" label="区代v3" :value="3">区代v3</el-option>
								<el-option :key="4" label="市代v4" :value="4">市代v4</el-option>
								<el-option :key="5" label="省代v5" :value="5">省代v5</el-option>
								<el-option :key="6" label="分公司v6" :value="6">分公司v6</el-option>
								<el-option :key="7" label="合伙人v7" :value="7">合伙人v7</el-option>
							</el-select>
						</el-form-item>
						<!-- 		<el-form-item label="社区级别:" label-width="80px">
							<el-select v-model="userForm.vipLevel" class="big" placeholder="请选择社区级别" clear>
								<el-option :key="0" label="请选择" :value="0">请选择</el-option>
								<el-option :key="1" label="部长" :value="1">部长</el-option>
								<el-option :key="2" label="经理" :value="2">经理</el-option>
								<el-option :key="3" label="总监" :value="3">总监</el-option>
							</el-select>
						</el-form-item> -->
					</div>
				</el-form>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="editUserDialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="editUserinfo()">确 定</el-button>
			</div>
		</el-dialog>
		<!-- 设置代理 -->
		<el-dialog style="float:rigin" title="设置代理" :visible.sync="editAgentDialogVisible" :close-on-click-modal="false"
			width="50%">
			<div class="app-container" style="text-align: center;">
				<el-form size="medium">
					<!-- <div style="display: flex;align-items: center;justify-content: space-between;">
						<el-form-item label="代理类型:" label-width="80px">
							<el-select v-model="setTLevelData.agentLevel" placeholder="请选择代理类型"
								@change="handleAgentLevel(setTLevelData.agentLevel)">
								<el-option :key="1" label="省代" :value="1">省代</el-option>
								<el-option :key="2" label="市代" :value="2">市代</el-option>
								<el-option :key="3" label="区代" :value="3">区代</el-option>
							</el-select>
						</el-form-item>
					</div> -->
					<div style="display: flex;align-items: center;justify-content: space-between;"
						v-if="setTLevelData.agentLevel>=1">
						<el-form-item label="省:" label-width="80px">
							<el-select v-model="setTLevelData.provinceId.name" placeholder="请选择省"
								@change="handleProvinceId(setTLevelData.provinceId)">
								<el-option :key="item.id" :label="item.name" :value="item.id"
									v-for="(item,index) in province">{{item.name}}</el-option>
							</el-select>
						</el-form-item>
					</div>
					<div style="display: flex;align-items: center;justify-content: space-between;"
						v-if="setTLevelData.agentLevel>=2">
						<el-form-item label="市:" label-width="80px">
							<el-select v-model="setTLevelData.cityId.name" placeholder="请选择市"
								@change="handleCityId(setTLevelData.cityId)">
								<el-option :key="item.id" :label="item.name" :value="item.id"
									v-for="(item,index) in city">{{item.name}}</el-option>
							</el-select>
						</el-form-item>
					</div>
					<div style="display: flex;align-items: center;justify-content: space-between;"
						v-if="setTLevelData.agentLevel>=3">
						<el-form-item label="区/县:" label-width="80px">
							<el-select v-model="setTLevelData.areaId.name" placeholder="请选择区/县"
								@change="handleAreaId(setTLevelData.areaId)">
								<el-option :key="item.id" :label="item.name" :value="item.id"
									v-for="(item,index) in area">{{item.name}}</el-option>
							</el-select>
						</el-form-item>
					</div>
					<div style="display: flex;align-items: center;justify-content: space-between;">
						<el-form-item label="是否启用:" label-width="80px" style="display: flex;align-items: center;">
							<el-switch v-model="setTLevelData.status" :active-value="true" :inactive-value="false">
							</el-switch>
						</el-form-item>
					</div>
				</el-form>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="editAgentDialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="editAgent()">确 定</el-button>
			</div>
		</el-dialog>
		<!-- 重置密码 -->
		<el-dialog style="float: rigin" title="编辑" :visible.sync="editDialogVisible" width="35%" :close-on-click-modal="false">
			<div class="app-container">
				<el-form ref="form" :model="form" :rules="mainFormRules" :label-width="formLabelWidth" size="medium">
					<el-form-item :label-width="formLabelWidth" label="登录密码:">
						<el-col :span="18">
							<el-input v-model="form.password" placeholder="请输入登录密码（6-16位字母+数字）" />
						</el-col>
					</el-form-item>
					<el-form-item :label-width="formLabelWidth" label="确认登录密码:">
						<el-col :span="18">
							<el-input v-model="form.surePass" placeholder="请输入确认登录密码" />
						</el-col>
					</el-form-item>

					<el-form-item>
						<el-button :loading="loading" type="primary" @click="resetPass()">提交</el-button>
						<el-button @click="cannelPass">取 消</el-button>
						<!-- <el-button type="primary" @click="insertRoleFunctionFun">确 定</el-button> -->
					</el-form-item>
				</el-form>
			</div>
		</el-dialog>
		<!-- 充值 -->
		<el-dialog style="float:rigin" title="充值" :visible.sync="dialogVisible" width="30%" :close-on-click-modal="false">
			<div class="app-container" style="text-align: center;">
				<el-form label-width="100px" size="medium">
					<el-form-item label="资产:">
						<el-col :span="8">
							<el-select v-model="integralId" class="big" placeholder="请选择" clear>
								<el-option v-for="item in integralList" :key="item.id" :value="item.id"
									:label="item.name">
								</el-option>
							</el-select>
						</el-col>
					</el-form-item>

					<el-form-item label="充值数量:">
						<el-col :span="10">
							<el-input type="number" v-model="appropriation" placeholder="请输入充值数量" />
						</el-col>
					</el-form-item>
				</el-form>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">取 消</el-button>
				<el-button type="primary" @click="sure" :loading="loading">确 定</el-button>
			</div>
		</el-dialog>
		<!-- 邀请下级 -->
		<el-dialog style="float:rigin" title="邀请下级" :visible.sync="inviteDialogVisible" width="50%"
		:close-on-click-modal="false"
			@close="inviteDialogVisible = false">
			<el-table :data="inviteData.list" stripe style="width: 100%;" :header-cell-style="headClass"
				v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" row-key="id"
				:tree-props="{children: 'children', hasChildren: 'hasChildren'}">
				<el-table-column prop="id" label="用户ID" align="center" :show-overflow-tooltip="true">
				</el-table-column>
				<el-table-column prop="username" label="账号" align="center" :show-overflow-tooltip="true">
				</el-table-column>
				<el-table-column prop="nickname" label="昵称" align="center" :show-overflow-tooltip="true">
				</el-table-column>
				<el-table-column prop="phone" label="手机号" align="center" :show-overflow-tooltip="true">
				</el-table-column>
				<el-table-column label="会员等级" prop="isActivate" align="center" :label-width="formLabelWidth">
					<template slot-scope="scope">
						<p v-if="scope.row.userLevel==0">会员</p>
						<p v-if="scope.row.userLevel==1">经理v1</p>
						<p v-if="scope.row.userLevel==2">县代v2</p>
						<p v-if="scope.row.userLevel==3">区代v3</p>
						<p v-if="scope.row.userLevel==4">市代v4</p>
						<p v-if="scope.row.userLevel==5">省代v5</p>
						<p v-if="scope.row.userLevel==6">分公司v6</p>
						<p v-if="scope.row.userLevel==7">合伙人v7</p>
					</template>
				</el-table-column>
			</el-table>
			<el-pagination style="margin: 20px;" background :current-page="inviteData.pageNum"
				@current-change="pageInviteChange" layout="total, sizes, prev, pager,next" :total="inviteData.total"
				@size-change="handleInviteSizeChange">
			</el-pagination>
			<span slot="footer" class="dialog-footer">
				<el-button @click="inviteDialogVisible = false">返回</el-button>
			</span>
		</el-dialog>
		<el-dialog style="float:rigin" title="流量池变动记录" :visible.sync="FLDialogVisible" width="50%"
		:close-on-click-modal="false">
			<el-table :data="userPropertyListFl.list" stripe style="width: 100%;" :header-cell-style="headClass"
				v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading" row-key="id"
				:tree-props="{children: 'children', hasChildren: 'hasChildren'}">
				<el-table-column prop="amount" label="变动金额" align="center" :show-overflow-tooltip="true">
				</el-table-column>
				<el-table-column prop="changeType" label="变动类型" align="center" :label-width="formLabelWidth">
					<template slot-scope="scope">
						<p v-if="scope.row.changeType==0">减少</p>
						<p v-if="scope.row.changeType==1">增加</p>
					</template>
				</el-table-column>
				<el-table-column prop="remark" label="备注" align="center" :show-overflow-tooltip="true">
				</el-table-column>
				<el-table-column prop="createTime" label="创建时间" align="center" :show-overflow-tooltip="true">
				</el-table-column>
				<el-table-column prop="isComplete" label="状态" align="center" :label-width="formLabelWidth">
					<template slot-scope="scope">
						<p v-if="scope.row.isComplete==0">未完成</p>
						<p v-if="scope.row.isComplete==1">完成</p>
					</template>
				</el-table-column>
			</el-table>
			<el-pagination style="margin: 20px;" background :current-page="userPropertyListFl.pageNum"
				@current-change="pageFlChange" layout="total, sizes, prev, pager,next" :total="userPropertyListFl.total"
				@size-change="handleFlSizeChange">
			</el-pagination>
			<span slot="footer" class="dialog-footer">
				<el-button @click="FLDialogVisible = false">返回</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				loading: false,
				userList: [{}], //用户列表
				propertyDialogVisible: false,
				inviteDialogVisible: false,
				dialogVisible: false,
				editDialogVisible: false,
				editUserDialogVisible: false, // 编辑用户弹窗
				editAgentDialogVisible: false, // 设置代理弹窗
				integralList: [],
				integralId: "", //积分id
				appropriation: "",
				ids: '', //授权用户id
				userData: [{}], //用户角色列表
				userDataList: [], //用户角色列表选中的
				formLabelWidth: "200px",
				form: {
					username: "",
					password: "",
					surePass: "",
					userLevel: "",
					userLevel: "",
					vipLevel: "",
				},
				userPropertyList: [],
				mainFormRules: {
					username: {
						required: true,
						message: "请输入账号",
						trigger: "blur"
					},
					password: {
						required: true,
						message: "请输入密码",
						trigger: "blur"
					},
				},
				userPropertyListFl: [],
				page: {
					pageNum: 1,
					pageSize: 10,
					invitePageNum: 1,
					invitePageSize: 10,
					FlPageNum: 1,
					FlPageSize: 10
				},
				editPassword: false,
				searchInfo: {},
				inviteData: [],
				//设置代理弹窗
				setTLevelDialogVisible: false,
				setTLevelData: {
					agentLevel: "",
					provinceId: "",
					cityId: "",
					areaId: "",
					status: false,
					userId: "",
					id: "",
					data: [{
							name: ""
						},
						{
							name: ""
						},
						{
							name: ""
						}
					]
				},
				setTLevelDataList: [],
				FLDialogVisible: false,
				agentCount: 0,
				userForm: {},
				logo: "",
				province: [],
				city: [],
				area: [],
				flag: 0
			};
		},
		methods: {
			//导出
			downloadFile() {
				let data = {
					phone: this.searchInfo.phone ? this.searchInfo.phone : "",
					nickname: this.searchInfo.nickname ? this.searchInfo.nickname : "",
					userLevel: this.searchInfo.userLevel,
					startTime: this.searchInfo.timer ? this.searchInfo.timer[0] : "",
					cutOffTime: this.searchInfo.timer ? this.searchInfo.timer[1] : "",
				};
				// console.log(data);
				this.$api.memberListExcel(data).then((res) => {
					// console.log(res.data);
					this.showloadFile(res.data);
				});
			},
			showloadFile(res) {
				if (!res) {
					return;
				}
				const link = document.createElement("a");
				let blob = new Blob([res], {
					type: "application/vnd.ms-excel",
				});
				link.style.display = "none";
				link.href = URL.createObjectURL(blob);
				link.setAttribute("download", "会员列表" + ".xls");
				document.body.appendChild(link);
				link.click();
				URL.revokeObjectURL(link.href); // 释放URL 对象
				document.body.removeChild(link);
			},
			handleAgentLevel(v) {
				if (this.flag == 1) {

					if (!this.setTLevelData.cityId) {
						this.setTLevelData.cityId = {
							name: "",
							id: ""
						}
						this.setTLevelData.areaId = {
							name: "",
							id: ""
						}
					} else if (!this.setTLevelData.areaId) {
						this.setTLevelData.areaId = {
							name: "",
							id: ""
						}
					}
				} else if (this.flag == 0) {
					this.setTLevelData.provinceId = {
						name: "",
						id: ""
					}
					this.setTLevelData.cityId = {
						name: "",
						id: ""
					}
					this.setTLevelData.areaId = {
						name: "",
						id: ""
					}
				}
				if (v === 1) {
					delete this.setTLevelData.cityId
					delete this.setTLevelData.areaId
				} else if (v === 2) {
					delete this.setTLevelData.areaId
				}
			},
			handleProvinceId(item) {
				// console.log(isNaN(item.name),item)
				if (isNaN(item.name)) {
					this.$api.getArea(item.id).then((res) => {
						this.city = res.data
					});
				} else if (isNaN(item.name) == false) {
					this.$api.getArea(item.name).then((res) => {
						this.city = res.data
					});
				}

				this.setTLevelData.data[0] = item
				// this.setTLevelData.provinceId.id=item.id
			},
			handleCityId(item) {
				// console.log(isNaN(item.name),item)
				if (isNaN(item.name)) {
					// this.$api.getArea(item.id).then((res) => {
					// 	this.area = res.data
					// });
				} else if (isNaN(item.name) == false) {
					this.$api.getArea(item.name).then((res) => {
						this.area = res.data
					});
				}

				this.setTLevelData.data[1] = item
				// this.setTLevelData.cityId.id=item.id
			},
			handleAreaId(item) {
				// console.log(item)
				this.setTLevelData.data[2] = item
				// this.setTLevelData.areaId.id=item.id
			},
			Area() {
				this.$api.getArea(0).then((res) => {
					this.province = res.data
				});
			},
			editUserinfo() {

				let data = {
					id: this.ids,
					userLevel: this.userForm.userLevel,
					vipLevel: this.userForm.vipLevel,
				};
				this.$api.editUserInfoById(data).then((res) => {
					if (res.state == "success") {
						this.$message({
							message: res.message,
							type: "success",
						});
						this.getUserList();
					} else {
						this.$message.error(res.message);
					}
					this.editUserDialogVisible = false;
				});

			},
			editAgent() {
				if (this.flag == 1) {
					let upAgency = {
						userId: this.setTLevelData.userId,
						id: this.setTLevelData.id,
						username: this.userForm.username,
						agentLevel: this.setTLevelData.agentLevel,
						areaId: "",
						status: this.setTLevelData.status,
					}
					if (upAgency.agentLevel == 1) {
						if (isNaN(this.setTLevelData.data[0].name)) {
							upAgency.areaId = this.setTLevelData.data[0].id
						} else {
							upAgency.areaId = this.setTLevelData.data[0].name
						}

					} else if (upAgency.agentLevel == 2) {
						if (isNaN(this.setTLevelData.data[1].name)) {
							upAgency.areaId = this.setTLevelData.data[1].id
						} else {
							upAgency.areaId = this.setTLevelData.data[1].name
						}
					} else if (upAgency.agentLevel == 3) {
						if (isNaN(this.setTLevelData.data[2].name)) {
							upAgency.areaId = this.setTLevelData.data[2].id
						} else {
							upAgency.areaId = this.setTLevelData.data[2].name
						}
					}
					// console.log(upAgency, this.setTLevelData.data)
					this.$api.updateUserArea(upAgency).then((res) => {
						if (res.state == "success") {
							this.$message({
								message: res.message,
								type: "success",
							});
							this.getUserList();
						} else if (res.status == 400) {
							this.$message.error("请重新选择");
						} else {
							this.$message.error(res.message);
						}
						this.editAgentDialogVisible = false;
					});

				} else {
					let agency = {
						userId: this.userForm.id,
						username: this.userForm.username,
						agentLevel: this.setTLevelData.agentLevel,
						areaId: " ",
						status: this.setTLevelData.status
					}
					// console.log(this.setTLevelData, this.userForm)
					if (agency.agentLevel == 1) {
						agency.areaId = this.setTLevelData.data[0].name
					} else if (agency.agentLevel == 2) {
						agency.areaId = this.setTLevelData.data[1].name
					} else if (agency.agentLevel == 3) {
						agency.areaId = this.setTLevelData.data[2].name
					}
					// console.log(agency)
					this.$api.addUserArea(agency).then((res) => {
						if (res.state == "success") {
							this.$message({
								message: res.message,
								type: "success",
							});
							this.getUserList();
						} else {
							this.$message.error(res.message);
						}
						this.editAgentDialogVisible = false;
					});
				}
			},
			resetPass() {
				if (this.form.password !== this.form.surePass) {
					this.$message.error("两次密码不一致");
					return false;
				}
				var reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,16}$/;
				var re = new RegExp(reg);
				if (!re.test(this.form.password)) {
					this.$message.error("请输入有效的登录密码");
					return false;
				}

				let data = {
					id: this.ids,
					password: this.form.password,
				};
				// console.log(data)
				this.$api.resetPass(data).then((res) => {
					if (res.state == "success") {
						this.$message({
							message: res.message,
							type: "success",
						});
						this.getUserList();
					} else {
						this.$message.error(res.message);
					}
					this.editDialogVisible = false;
				});
			},
			toEditPassword(id) {
				this.form.password = "";
				this.form.surePass = "";
				this.ids = id;
				this.editDialogVisible = true;
			},
			changeNull(row, column, cellValue) {
				if (cellValue) {
					return cellValue;
				} else {
					return "暂无";
				}
			},
			empty() {
				this.searchInfo = {}
			},
			search() {
				this.page.pageNum = 1;
				this.getUserList()
			},
			findSysUserById(id) {
				this.$api.findSysUserById(id).then((res) => {
					if (res.state == 'success') {
						this.form.username = res.data.username
					}
				})
			},
			cannelPass() {
				this.editDialogVisible = false
				this.loading = false
			},
			showEditAgentDialogVisible(id) {
				this.editAgentDialogVisible = true
				this.userForm = {}
				this.setTLevelData = {
					agentLevel: "",
					provinceId: "",
					cityId: "",
					areaId: "",
					status: false,
					userId: "",
					id: "",
					data: []
				}
				this.$api.getUserInfoById({
					id: id
				}).then((res) => {
					if (res.state == 'success') {
						this.userForm = res.data
						// this.logo = res.data.logo
					}
				})
				this.$api.findUserArea({
					id: id
				}).then((respon) => {
					if (respon.state === "success") {
						this.setTLevelData.userId = id
						if (respon.data.UserArea) {
							this.flag = 1
							this.setTLevelData.agentLevel = respon.data.UserArea.agentLevel
							this.setTLevelData.status = respon.data.UserArea.status
							this.setTLevelData.id = respon.data ? respon.data.UserArea.id : ""
							this.setTLevelData.provinceId = respon.data.area[0] ? respon.data.area[
								0] : ""
							this.setTLevelData.cityId = respon.data.area[1] ? respon.data.area[1] :
								""
							this.setTLevelData.areaId = respon.data.area[2] ? respon.data.area[2] :
								""
							this.setTLevelData.data[0] = respon.data.area[0]
							this.setTLevelData.data[1] = respon.data.area[1]
							this.setTLevelData.data[2] = respon.data.area[2]
							this.$forceUpdate()
							// console.log(this.setTLevelData)
							if (this.setTLevelData.provinceId) {
								this.$api.getArea(respon.data.area[0].id).then((res) => {
									this.city = res.data
								});
							}
							if (this.setTLevelData.cityId) {
								this.$api.getArea(respon.data.area[1].id).then((res) => {
									this.area = res.data
								});

							}
							this.$forceUpdate()
						} else {
							this.setTLevelData = {
								agentLevel: "",
								provinceId: {
									name: "",
									id: ""
								},
								cityId: {
									name: "",
									id: ""
								},
								areaId: {
									name: "",
									id: ""
								},
								status: false,
								userId: "",
								id: "",
								data: []
							}
							this.flag = 0
						}
						this.$forceUpdate()
						// console.log(this.setTLevelData)
					}
				})
			},
			showEditUserDialogVisible(id) {
				this.userForm = {}
				this.ids = id
				this.editUserDialogVisible = true
				this.$api.getUserInfoById({
					id: id
				}).then((res) => {
					if (res.state == 'success') {
						this.userForm = res.data
						this.logo = res.data.logo
					}
				})
			},
			//上传logo
			upLoadLogo(param) {
				const formData = new FormData()
				formData.append('file', param.file)
				this.$api.uploadFile(formData, "goods").then((res) => {
					// console.log('列表:', res);
					this.logo = res.data
				})
			},
			// 上传图片前，筛选
			beforeAvatarUpload(file) {
				const isLt2M = file.size / 1024 / 1024 < 8;
				if (!isLt2M) {
					this.$message.error('上传图片大小不能超过 8MB!');
					return false;
				};
				var imgStr = /\.(jpg|jpeg|png|bmp|BMP|JPG|PNG|JPEG)$/;
				if (!imgStr.test(file.name)) {
					this.$message.error("文件不是图片类型，请上传正确格式图片！");
					return false;
				};
				return isLt2M, imgStr;
			},
			//重置密码弹框
			editialogVisible(id) {
				this.form.password = ""
				this.form.surePass = ""
				this.ids = id
				this.editPassword = true;
			},

			// 充值弹窗
			dialogVisibleFun(id) {
				this.ids = id
				this.integralId = ''
				this.appropriation = ''
				this.dialogVisible = true;
			},
			//提交充值
			sure() {
				this.loading = true
				let data = {
					userId: this.ids,
					integralId: this.integralId,
					appropriation: this.appropriation
				}
				this.$api.getIntegralAppropriation(data).then((res) => {
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.getUserList()
					} else {
						this.$message.error(res.message);
					}
					this.loading = false
					this.dialogVisible = false;
				})
			},
			//删除
			toDelete(row) {
				if (row.isEnable) {
					var str = "确认要禁用该用户, 是否继续?"
				} else {
					var str = "确认要启用该用户, 是否继续?"
				}
				this.$confirm(str, '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					if (row.isEnable) {
						var data = {
							id: row.id,
							isEnable: false,
							isDelete: true
						}
					} else {
						var data = {
							id: row.id,
							isEnable: true,
							isDelete: false
						}
					}
					this.$api.disableUserInfo(data).then((res) => {
						if (res.state == 'success') {
							this.$message({
								message: res.message,
								type: 'success'
							});
							this.getUserList();
						} else {
							this.$message.error(res.message);
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			},
			headClass() {
				return 'text-align:center;background:#E6E9F0;color: rgb(31, 46, 77);height:56px'
			},
			formartDate(row, column) {
				var ymdhis = "";
				if (row) {
					var time = new Date(row);
					ymdhis += time.getFullYear() + "-";
					ymdhis += ((time.getMonth() + 1) < 10 ? '0' + (time.getMonth() + 1) : (time
						.getMonth() + 1)) + "-";
					ymdhis += (time.getDate() < 10 ? '0' + time.getDate() : time.getDate()) + ' ';
					ymdhis += (time.getHours() < 10 ? '0' + time.getHours() : time.getHours()) + ":";
					ymdhis += (time.getMinutes() < 10 ? '0' + time.getMinutes() : time.getMinutes()) + ":";
					ymdhis += (time.getSeconds() < 10 ? '0' + time.getSeconds() : time.getSeconds());
					return ymdhis;
				} else {
					return '无';
				}

			},
			pageChange(data) {
				this.page.pageNum = data
				this.getUserList()
			},
			handleSizeChange(val) {
				this.page.pageSize = val
				this.getUserList()
			},
			getUserList() {
				this.loading = true
				let data = {
					pageNum: this.page.pageNum,
					pageSize: this.page.pageSize,
					invitationCode: this.searchInfo.invitationCode,
					startTime: this.searchInfo.timer ? this.searchInfo.timer[0] : "",
					cutOffTime: this.searchInfo.timer ? this.searchInfo.timer[1] : "",
					phone: this.searchInfo.phone,
					id: this.searchInfo.id,
					nickname: this.searchInfo.nickname,
					username: this.searchInfo.username,
					isEnable: this.searchInfo.isEnable,
					isLeader: this.searchInfo.isLeader,
					userLevel: this.searchInfo.userLevel,
					// userLevel: this.searchInfo.userLevel,
					vipLevel: this.searchInfo.vipLevel,
					agentLevel: this.searchInfo.agentLevel,
				}
				this.$api.getUserList(data).then((res) => { //角色管理列表
					// console.log('角色管理列表:', res);
					if (res.state == 'success') {
						this.userList = res.data
						this.loading = false
					}
				})
			},
			toShowProperty(userId) {
				this.userPropertyList = []
				this.propertyDialogVisible = true
				this.$api.getUserProperty({
					pageNum: this.page.pageNum,
					pageSize: this.page.pageSize,
					userId: userId
				}).then((res) => { //角色管理列表
					// console.log('角色管理列表:', res);
					if (res.state == 'success') {
						this.userPropertyList = res.data.list.list
					}
				})

			},
			toShowInvite(userId) {
				this.inviteData = []
				this.ids = userId
				this.inviteDialogVisible = true
				this.showInvite(userId);
			},
			toShowPropertyFl(userId) {
				this.userPropertyListFl = []
				this.ids = userId
				this.FLDialogVisible = true
				this.showFl(userId);
			},
			showFl(userId) {
				this.loading = true
				let data = {
					userId: this.ids,
					pageNum: this.page.FlPageNum,
					pageSize: this.page.FlPageSize,
				}
				this.$api.findFlowRecord(data).then((res) => { //角色管理列表
					if (res.state == 'success') {
						this.userPropertyListFl = res.data
					}
					this.loading = false
				})
			},
			pageFlChange(data) {
				this.page.FlPageNum = data
				this.showFl(this.ids)
			},
			handleFlSizeChange(val) {
				this.page.FlPageSize = val
				this.showFl(this.ids)
			},
			pageInviteChange(data) {
				this.page.invitePageNum = data
				this.showInvite(this.ids)
			},
			handleInviteSizeChange(val) {
				this.page.invitePageSize = val
				this.showInvite(this.ids)
			},
			showInvite(userId) {
				this.loading = true
				let data = {
					id: this.ids,
					pageNum: this.page.invitePageNum,
					pageSize: this.page.invitePageSize,
				}
				this.$api.showInvite(data).then((res) => { //角色管理列表
					if (res.state == 'success') {
						this.inviteData = res.data
					}
					this.loading = false
				})
			}

		},
		created() {
			this.getUserList();
			this.Area()
			this.$api.getIntegralList().then((res) => {
				if (res.state == 'success') {
					this.integralList = res.data
				}
			})
		}
	};
</script>

<style>
	.demo-table-expand {
		font-size: 0;
	}

	.demo-table-expand label {
		width: 100px;
		color: #99a9bf;
	}

	.demo-table-expand .el-form-item {
		margin-right: 0;
		margin-bottom: 0;
		width: 50%;
	}
</style>
